<div>

  <dx-scroll-view data-testid="new-task-scroll-view">
    <div [ngSwitch]="addNewTemplateType">
        <div *ngSwitchCase="'Voucher Request'">
          <app-voucher data-testid="new-task-voucher" (onAddNewTaskEventEmitter)="onAddNewTask($event)" [taskTemplateName]="taskTemplateName" [task]="task">
          </app-voucher>
        </div>
        <div *ngSwitchCase="'Borrower Draw'">
          <app-borrower-draw-request data-testid="new-task-borrower-draw-request" (onAddNewTaskEventEmitter)="onAddNewTask($event)" [taskTemplateName]="taskTemplateName" [task]="task"></app-borrower-draw-request>
        </div>
        <div *ngSwitchCase="'Servicing Request'">
          <app-service-request data-testid="new-task-service-request" (onAddNewTaskEventEmitter)="onAddNewTask($event)" [taskTemplateName]="taskTemplateName" [task]="task"></app-service-request>
        </div>
        <div *ngSwitchCase="'New Deal Onboarding'">
          <app-pipeline data-testid="new-task-new-deal-onboarding" (onAddNewTaskEventEmitter)="onAddNewTask($event)" [taskTemplateName]="taskTemplateName" [task]="task"></app-pipeline>
        </div>
        <div *ngSwitchCase="'Modification'">
          <app-modification data-testid="new-task-modification" (onAddNewTaskEventEmitter)="onAddNewTask($event)" [taskTemplateName]="taskTemplateName" [task]="task"></app-modification>
        </div>
        <div *ngSwitchCase="'Treasury Request'">
          <app-treasury-request data-testid="new-task-treasury-request" (onAddNewTaskEventEmitter)="onAddNewTask($event)" [taskTemplateName]="taskTemplateName" [task]="task"></app-treasury-request>
        </div>
        <div *ngSwitchCase="'Default Notification'">
          <app-default-notification data-testid="new-task-default-notification" (onAddNewTaskEventEmitter)="onAddNewTask($event)" [taskTemplateName]="taskTemplateName" [task]="task"></app-default-notification>
        </div>
        <div *ngSwitchCase="'Vendor Request'">
          <app-vendor-request data-testid="new-task-vendor-request" (onAddNewTaskEventEmitter)="onAddNewTask($event)" [taskTemplateName]="taskTemplateName" [task]="task"></app-vendor-request>
        </div>
        <div *ngSwitchCase="'Decommissions/Paydowns'">
          <app-payoff-paydown data-testid="new-task-payoff-paydown" (onAddNewTaskEventEmitter)="onAddNewTask($event)" [taskTemplateName]="taskTemplateName" [task]="task"></app-payoff-paydown>
        </div>
        <div *ngSwitchCase="'Financial and Compliance'">
          <app-fandc-generator data-testid="new-task-fandc-generator" (onAddNewTaskEventEmitter)="onAddNewTask($event)" [taskGenerationMetadata]="taskMetadata" [taskTemplateName]="taskTemplateName"></app-fandc-generator>
        </div>
        <div *ngSwitchCase="'Suspense Request'">
          <app-suspense data-testid="new-task-suspense" (onAddNewTaskEventEmitter)="onAddNewTask($event)" [taskTemplateName]="taskTemplateName" [task]="task"></app-suspense>
        </div>
        <div *ngSwitchCase="'Dynamic Servicing Request'">
          <app-service-request-dynamic data-testid="new-task-service-request-dynamic" (onAddNewTaskEventEmitter)="onAddNewTask($event)" [taskTemplateName]="taskTemplateName" [task]="task"></app-service-request-dynamic>
        </div>
        <div *ngSwitchCase="'Aviva Surveillance'">
          <app-service-request-dynamic data-testid="new-task-aviva-service-request-dynamic" (onAddNewTaskEventEmitter)="onAddNewTask($event)" [taskTemplateName]="taskTemplateName" [linkedTemplateFilter]="'Loan Event - Amendment of Security'" [task]="task"></app-service-request-dynamic>
        </div>
        <div *ngSwitchDefault>No task type available!</div>
      </div>

    </dx-scroll-view>
</div>